import { render, staticRenderFns } from "./ValueWidget.vue?vue&type=template&id=389eb891&"
import script from "./ValueWidget.vue?vue&type=script&lang=ts&"
export * from "./ValueWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports